import {
    FETCHED_ROLES,
    FETCHED_PERMISSIONS,
    FETCHED_ROLES_PERMISSIONS,
    CHANGE_ROLE_PERMISSION,
    FETCHED_PERMISSIONS_GROUPS,
    UPDATED_ROLES_PERMISSIONS
} from './types';
import _sortBy from 'lodash/sortBy';
import update from 'immutability-helper';

const INITIAL_STATE = {
    allRoles: [],
    allPermissions: [],
    rolesPermissions: [],
    permissionsGroups: [],
    touched: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case FETCHED_ROLES:

            let sortedRoles = _sortBy(action.payload.data, 'display_name');

            return update(state, {allRoles: {
                $set: sortedRoles
            }});

        case FETCHED_PERMISSIONS:

            return update(state, {allPermissions: {
                $set: action.payload.data
            }});

        case FETCHED_PERMISSIONS_GROUPS:

            return update(state, {permissionsGroups: {
                $set: action.payload.data
            }});

        case UPDATED_ROLES_PERMISSIONS:

            return update(state, {
                touched: {$set: action.payload.touched }
            });

        case FETCHED_ROLES_PERMISSIONS:

            let rolesPerms = [];
            action.payload.data.forEach(role => {
                let roleId = role.role_id;
                rolesPerms[roleId] = {};
                role.permissions.forEach(permission => {
                    rolesPerms[roleId][permission.permission_id] = true;
                });
            });
            return update(state, {
                rolesPermissions: {$set: rolesPerms },
                touched: {$set: action.payload.touched }
            });

        case CHANGE_ROLE_PERMISSION:

            let perm = {};
            perm[action.payload.permId] = action.payload.checked;
            return update(state, {
                rolesPermissions: {
                    [action.payload.roleId]: {$merge: perm }
                },
                touched: {$set: action.payload.touched }
            });

        default:
            return state;
    }
}

 


// WEBPACK FOOTER //
// ./src/containers/roles/reducer.js